import React from "react";
import styled from "styled-components";
import countries from "react-phone-number-input/build/country names";

import Gettext from "./common/Gettext";
import Flag from "./common/Flag";
import ProjectTitle from "./ProjectTitle";
import Image from "../images/BlockedCountry.png";

const countryList = countries.reduce((res, country) => {
  res[country[0]] = country[1];
  return res;
}, {});

const Popup = styled.div`
  display: table;
  text-align: center;
  vertical-align: middle;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  max-width: 450px;
  // padding: 20px 0;
  margin: auto;
`;

const PopupInner = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

const WarnSection = styled.div`
  position: relative;
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 5px;
  padding: 30px 20px;
  font-weight: 700;
  font-size: 16px;
  line-height: normal;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 280px;
  }

  @media (max-width: 360px) {
    max-width: 240px;
  }
`;

const Red = styled.div`
  padding-top: 25px;
  color: #e74c3c;
  font-size: 20px;
  font-weight: 700;
`;

const Text = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 20px;
  color: #343434;
`;

const Contact = styled.div`
  color: #95989a;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1.4;
`;

const A = styled.a`
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: #3598db;
`;

const BlockedCountry = props => {
  const countryFlag = (props.country &&
    <React.Fragment>
      {countryList[props.country.toLowerCase()]}&nbsp;<Flag country={props.country.toLowerCase()} />
    </React.Fragment>
  );

  return (
  <Popup>
    <PopupInner>
      <WarnSection>
        <img src={Image} alt={""} />
        <Red>
          <Gettext>Attention!</Gettext>
        </Red>
        <Text>
          <Gettext>
            Dear user, <ProjectTitle /> is unavailable in your country.
          </Gettext>
        </Text>
        {props.country && <Text>
          <Gettext>
            Your country: {countryFlag}
          </Gettext>
        </Text>}
        <Contact>
          <Gettext>
            The financial services on this website are not available to the residents of the following countries: USA, Canada, European Economic Area, Russia, Switzerland, Israel, New Zealand, Australia, Japan, North Korea, Puerto Rico, Sudan, Iran, Liberia, Pakistan, Syria.
          </Gettext>
        </Contact>
        <br/>
        <Contact>
          <Gettext>
            If you think you see this message by mistake, please contact us at <A href={`mailto:${props.email}`}>{props.email}</A>
          </Gettext>
        </Contact>
      </WarnSection>
    </PopupInner>
  </Popup>
)};

export default BlockedCountry;



// WEBPACK FOOTER //
// ./src/components/BlockedCountry.js